import regression from "regression";

(function (module) {
    "use strict";
    module.service('regressionCalculator', ['$http', '$q', function(this: $TSFixMe, $http: ng.IHttpService, $q: ng.IQService) {
        var service = this;

        service.postRegression = function (method: $TSFixMe, x: $TSFixMe, y: $TSFixMe, x_pred: $TSFixMe, starting_month_no: $TSFixMe) {

            if (x.length == 0 || y.length == 0) {
                return $q.when({
                    regression: x_pred,
                    r: 1
                });
            }

            return $http.post('/api/regression', {
                StartingMonthNo: starting_month_no,
                X: x,
                Y: y,
                XPred: x_pred,
                Method: method
            }).then(function (response: $TSFixMe) {
                let values: $TSFixMe = [];
                if (response.data.regression) {

                    angular.forEach(response.data.regression, function (value: $TSFixMe, key: $TSFixMe) {
                        values.push(value);
                    });
                }

                return {
                    regression: values,
                    r: response.data.r,
                    mape: response.data.mape
                };
            });

        };

        service.postML = function (machineLearningGuid: $TSFixMe) {
            return $http.post('/api/ml', { machineLearningGuid }).then((response: $TSFixMe) => response.data);
        };

        service.calculateLinear = function (inputArray: $TSFixMe, resultArguments: $TSFixMe) {
            var array: [number, number][] = [];
            for (var i = 0; i < inputArray.length; i++) {

                if (!angular.isUndefinedOrNull(inputArray[i])) {
                    array.push([i, parseFloat(inputArray[i])]);
                }
            }

            var result = regression.linear(array);
            var func = function (x: $TSFixMe) {
                return result.equation[0] * x + result.equation[1];
            }

            var output = [];
            for (var i = 0; i < resultArguments.length; i++) {
                output.push(func(resultArguments[i]));
            }
            return output;
        }

    }]);



})(angular.module("topline.services"));
